<div class="stellar-section">
  <div class="stellar-block inicio2">
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3074.880630833562!2d2.6380579774016186!3d39.58484057158548!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x129793c1bcf7480d%3A0x543379daa79e7b1!2sPizza%20En Casa!5e0!3m2!1ses!2ses!4v1724252610926!5m2!1ses!2ses"
      width="100%"
      height="450"
      style="border: 0"
      allowfullscreen="true"
      loading="lazy"
      referrerpolicy="no-referrer-when-downgrade"
    ></iframe>
  </div>
</div>
